/**
 * Allowed sites per domain.
 * @type {Object}
 */
const allowedSitesPerDomainData = {
    'gelosobeveragegroup.com': {
        primary: 'US_en_US',
        sites: ['US_en_US'],
    },
    'us.groupegeloso.dev': {
        primary: 'US_en_US',
        sites: ['US_en_US'],
    },
    'new.groupegeloso.dev': {
        primary: 'QC_fr_CA',
        sites: ['QC_fr_CA', 'QC_en_CA', 'CA_en_CA', 'CA_fr_CA', 'INTL_en_GB', 'INTL_fr_FR'],
    },
    'geloso.com': {
        primary: 'QC_fr_CA',
        sites: ['QC_fr_CA', 'QC_en_CA', 'CA_en_CA', 'CA_fr_CA', 'INTL_en_GB', 'INTL_fr_FR'],
    },
};

const useServerState = () => {
    // const allowedSitesPerDomain = useState('allowedSitesPerDomain', () => allowedSitesPerDomainData);

    return {
        allowedSitesPerDomain: allowedSitesPerDomainData,
    };
};

export default useServerState;
